// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container for About section */
.about-second-container {
    display: flex;
    gap: 40px;
    padding: 20px;
    background-color: #f9f9f9; /* Light background for better visibility */
    font-family: Arial, sans-serif;
  }
  
  /* Left column */
  .about-second-left {
    flex: 1 1; /* Take equal space as the right section */
    padding: 20px;
  }
  
  .about-second-left h1 {
    font-size: 2rem;
    margin-bottom: 15px;
  }
  
  .about-second-left h2 {
    font-size: 1.5rem;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  
  .about-second-left p {
    line-height: 1.6;
    color: #333;
  }
  
  /* Right column */
  .about-second-right {
    flex: 1 1; /* Take equal space as the left section */
    padding: 20px;
    background-color: #FAFAFA; /* White background for contrast */
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(10, 6, 6, 0.842); /* Subtle shadow for better separation */
  }
  
  .about-second-right h2 {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }
  
  .about-second-right ul {
    list-style: none;
    padding: 0;
  }
  
  .about-second-right ul li {
    margin-bottom: 15px;
    line-height: 1.5;
  }
  
  .about-second-right ul li strong {
    color: #0073e6; /* Highlight titles in blue */
  }
  
  /* Ensure responsiveness */
  /* Mobile View */
@media (max-width: 768px) {
    .about-second-container {
      flex-direction: column; /* Stack sections vertically */
      gap: 20px; /* Reduce gap between sections */
      padding: 15px; /* Adjust padding for smaller screens */
    }
  
    /* Left column */
    .about-second-left {
      padding: 10px; /* Reduce padding for mobile */
      text-align: left; /* Center-align text for better readability */
    }
  
    .about-second-left h1 {
      font-size: 1.8rem; /* Adjust heading size for mobile */
      margin-bottom: 10px;
    }
  
    .about-second-left h2 {
      font-size: 1.4rem; /* Adjust subheading size for mobile */
      margin-top: 15px;
      margin-bottom: 8px;
    }
  
    .about-second-left p {
      line-height: 1.5;
      font-size: 0.95rem; /* Slightly smaller font size for mobile */
      color: #333;
    }
  
    /* Right column */
    .about-second-right {
      padding: 10px; /* Reduce padding for mobile */
      background-color: #FAFAFA;
      border: 1px solid #ddd;
      border-radius: 8px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Subtle shadow for separation */
      text-align: left; /* Align text to the left for better readability */
    }
  
    .about-second-right h2 {
      font-size: 1.4rem; /* Adjust heading size for mobile */
      margin-bottom: 10px;
      text-align: center; /* Center-align text */
    }
  
    .about-second-right ul {
      padding: 0;
      margin: 0;
      list-style: none; /* Remove list styling for cleaner appearance */
    }
  
    .about-second-right ul li {
      margin-bottom: 10px; /* Reduce spacing between list items */
      line-height: 1.4; /* Adjust line height */
      font-size: 0.9rem; /* Slightly smaller font size for mobile */
      text-align: left; /* Keep text left-aligned */
    }
  
    .about-second-right ul li strong {
      color: #090b0e; /* Keep highlight titles in blue */
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/MainAboutSecond/MainAboutSecond.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,yBAAyB,EAAE,2CAA2C;IACtE,8BAA8B;EAChC;;EAEA,gBAAgB;EAChB;IACE,SAAO,EAAE,0CAA0C;IACnD,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA,iBAAiB;EACjB;IACE,SAAO,EAAE,yCAAyC;IAClD,aAAa;IACb,yBAAyB,EAAE,kCAAkC;IAC7D,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C,EAAE,wCAAwC;EACvF;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,cAAc,EAAE,6BAA6B;EAC/C;;EAEA,0BAA0B;EAC1B,gBAAgB;AAClB;IACI;MACE,sBAAsB,EAAE,8BAA8B;MACtD,SAAS,EAAE,gCAAgC;MAC3C,aAAa,EAAE,uCAAuC;IACxD;;IAEA,gBAAgB;IAChB;MACE,aAAa,EAAE,8BAA8B;MAC7C,gBAAgB,EAAE,6CAA6C;IACjE;;IAEA;MACE,iBAAiB,EAAE,mCAAmC;MACtD,mBAAmB;IACrB;;IAEA;MACE,iBAAiB,EAAE,sCAAsC;MACzD,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB,EAAE,0CAA0C;MAC9D,WAAW;IACb;;IAEA,iBAAiB;IACjB;MACE,aAAa,EAAE,8BAA8B;MAC7C,yBAAyB;MACzB,sBAAsB;MACtB,kBAAkB;MAClB,wCAAwC,EAAE,iCAAiC;MAC3E,gBAAgB,EAAE,kDAAkD;IACtE;;IAEA;MACE,iBAAiB,EAAE,mCAAmC;MACtD,mBAAmB;MACnB,kBAAkB,EAAE,sBAAsB;IAC5C;;IAEA;MACE,UAAU;MACV,SAAS;MACT,gBAAgB,EAAE,+CAA+C;IACnE;;IAEA;MACE,mBAAmB,EAAE,sCAAsC;MAC3D,gBAAgB,EAAE,uBAAuB;MACzC,iBAAiB,EAAE,0CAA0C;MAC7D,gBAAgB,EAAE,2BAA2B;IAC/C;;IAEA;MACE,cAAc,EAAE,kCAAkC;IACpD;AACJ","sourcesContent":["/* Main container for About section */\n.about-second-container {\n    display: flex;\n    gap: 40px;\n    padding: 20px;\n    background-color: #f9f9f9; /* Light background for better visibility */\n    font-family: Arial, sans-serif;\n  }\n  \n  /* Left column */\n  .about-second-left {\n    flex: 1; /* Take equal space as the right section */\n    padding: 20px;\n  }\n  \n  .about-second-left h1 {\n    font-size: 2rem;\n    margin-bottom: 15px;\n  }\n  \n  .about-second-left h2 {\n    font-size: 1.5rem;\n    margin-top: 20px;\n    margin-bottom: 10px;\n  }\n  \n  .about-second-left p {\n    line-height: 1.6;\n    color: #333;\n  }\n  \n  /* Right column */\n  .about-second-right {\n    flex: 1; /* Take equal space as the left section */\n    padding: 20px;\n    background-color: #FAFAFA; /* White background for contrast */\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 2px 5px rgba(10, 6, 6, 0.842); /* Subtle shadow for better separation */\n  }\n  \n  .about-second-right h2 {\n    font-size: 1.5rem;\n    margin-bottom: 15px;\n  }\n  \n  .about-second-right ul {\n    list-style: none;\n    padding: 0;\n  }\n  \n  .about-second-right ul li {\n    margin-bottom: 15px;\n    line-height: 1.5;\n  }\n  \n  .about-second-right ul li strong {\n    color: #0073e6; /* Highlight titles in blue */\n  }\n  \n  /* Ensure responsiveness */\n  /* Mobile View */\n@media (max-width: 768px) {\n    .about-second-container {\n      flex-direction: column; /* Stack sections vertically */\n      gap: 20px; /* Reduce gap between sections */\n      padding: 15px; /* Adjust padding for smaller screens */\n    }\n  \n    /* Left column */\n    .about-second-left {\n      padding: 10px; /* Reduce padding for mobile */\n      text-align: left; /* Center-align text for better readability */\n    }\n  \n    .about-second-left h1 {\n      font-size: 1.8rem; /* Adjust heading size for mobile */\n      margin-bottom: 10px;\n    }\n  \n    .about-second-left h2 {\n      font-size: 1.4rem; /* Adjust subheading size for mobile */\n      margin-top: 15px;\n      margin-bottom: 8px;\n    }\n  \n    .about-second-left p {\n      line-height: 1.5;\n      font-size: 0.95rem; /* Slightly smaller font size for mobile */\n      color: #333;\n    }\n  \n    /* Right column */\n    .about-second-right {\n      padding: 10px; /* Reduce padding for mobile */\n      background-color: #FAFAFA;\n      border: 1px solid #ddd;\n      border-radius: 8px;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Subtle shadow for separation */\n      text-align: left; /* Align text to the left for better readability */\n    }\n  \n    .about-second-right h2 {\n      font-size: 1.4rem; /* Adjust heading size for mobile */\n      margin-bottom: 10px;\n      text-align: center; /* Center-align text */\n    }\n  \n    .about-second-right ul {\n      padding: 0;\n      margin: 0;\n      list-style: none; /* Remove list styling for cleaner appearance */\n    }\n  \n    .about-second-right ul li {\n      margin-bottom: 10px; /* Reduce spacing between list items */\n      line-height: 1.4; /* Adjust line height */\n      font-size: 0.9rem; /* Slightly smaller font size for mobile */\n      text-align: left; /* Keep text left-aligned */\n    }\n  \n    .about-second-right ul li strong {\n      color: #090b0e; /* Keep highlight titles in blue */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
